import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../services/serviceCaller";
import { API_URL } from "../../../constants";
import { toast } from "react-toastify";
import No_Image_Available from "../../../assets/No_Image_Available.jpg";

import * as Yup from "yup";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import { FaSpinner } from "react-icons/fa";
const AwardEditForm = () => {
  const { id } = useParams();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(updateNavbarHeading("Award"));
  }, []);
  const iniitialFormData = [
    {
      EmployeeID: null,
      Name: "",
      Remarks: "",
      award_id: null,
    },
  ];
  const [loading, setLoading] = useState(false);

  const [awardTypeOption, setAwardTypeOption] = useState([]);
  const [employeeOption, setEmployeeOption] = useState([]);
  const [formData, setFormData] = useState([]);
  const [errors, setErrors] = useState("");
  const [remark, setRemark] = useState();
  const [value, setValue] = useState();
  const [description, setDescription] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  useEffect(() => {
    fetchGetData();
  }, []);

  const fetchGetData = async () => {
    try {
      let response;
      response = await GetServiceCaller(`${API_URL}awards`);

      if (response?.status === 200) {
         setPageLoading(false);
        const awardData = response?.data;
        const awardTypes = awardData?.awards?.map((record) => ({
          value: record.title_id,
          label: record.title,
        }));
        setAwardTypeOption(awardTypes);

        const employees = awardData?.employeeList?.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setEmployeeOption(employees);
      }
    } catch (error) {
      console.error("Fetching Error ", error);
    }
  };

  useEffect(() => {
    if (id) {
      fetchShowData(id);
    }
  }, [id]);
  const fetchShowData = async (id) => {
    try {
      let response;
      response = await GetServiceCaller(`${API_URL}awards/${id}`);

      if (response?.status === 200) {
        const awardData = response?.data?.data;
        setFormData({
          EmployeeID: awardData?.EmployeeID,
          Name: awardData?.Name,
          Remarks: awardData?.Remarks,
          award_id: awardData?.award_id,
        });
      }
    } catch (error) {
      console.error("Fetching Error ", error);
    }
  };
  useEffect(() => {
    if (formData?.award_id) {
      fetchBadges(formData?.award_id);
    }
  }, [formData?.award_id]);

  const fetchBadges = async (id) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}awards-badges?awardID=${id}`
      );
      if (response?.status === 200) {
        const badgeUrl = response?.data?.data[0]?.FileName;
        const scoreData = response?.data?.data[0]?.score;
        const descData = response?.data?.data[0]?.remarks;
        setDescription(descData);
        setFormData((prev) => ({
          ...prev,
          badge: badgeUrl,
          badgePreview: badgeUrl ? `${API_URL}${badgeUrl}` : null,
          score: scoreData,
        }));
      }
    } catch (error) {
      console.error("Fetching Badges Error", error);
    }
  };
  const schema = Yup.object().shape({
    EmployeeID: Yup.number().required("Employee is required"),
    award_id: Yup.number().required("Title is required"),
    Remarks: Yup.string(),
  });

  const validateField = async (fieldName, updatedData) => {
    try {
      // Validate the specific field
      await schema.validateAt(fieldName, updatedData);

      // Clear the error for the specific field if validation is successful
      setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
    } catch (err) {
      if (err.path === fieldName) {
        // Update the error only for the specific field
        setErrors((prevErrors) => ({
          ...prevErrors,
          [fieldName]: err.message,
        }));

        // Show error using toast for specific validation
        toast.error(err.message, { position: "top-right" });
      } else {
        console.error("Validation error structure is not as expected:", err);
      }
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Validate the entire form before submission
      await schema.validate(formData, { abortEarly: false });

      let response;

      response = await PostServiceCaller(
        `${API_URL}awards/${id}`,
        formData,
        "put"
      );

      if (response?.status === 200) {
        toast.success("Data submitted successfully");
        setTimeout(() => {
          navigate("/awards");
        }, 1000);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);

      console.error("Post Data Error ", error);
    }
  };

  const handleFileChange = (e, name) => {
    const file = e.target.files[0];
    if (file) {
      setValue(name, file);
    }
  };

  // Handle Select change
  const handleSelect = async (selectedOption, { name }) => {
    const updatedData = {
      ...formData,
      [name]: selectedOption.value,
      ...(name === "Name"
        ? {
            award_id: selectedOption.value,
            Name: selectedOption.label,
          }
        : {}),
    };

    setFormData(updatedData);
    await validateField(name, updatedData);
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;
    const updatedValue = name === "Name" ? value.toUpperCase() : value;

    const updatedData = {
      ...formData,
      [name]: updatedValue,
    };

    setFormData(updatedData);
    await validateField(name, updatedData);
  };

    if (pageLoading) {
      return (
        <>
          <p class="position-absolute top-50 start-50 translate-middle text-center">
            <FaSpinner class="spinner" />
          </p>
        </>
      );
    } else {
  return (
    <div className="container-fluid" id="skill_section">
      <div style={{ height: "fit-content" }}>
        <form className="card rounded mt-2 p-3" onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-4 mb-3">
              <label className="form-label">
                Employee <span className="text-danger">*</span>
              </label>
              <Select
                name="EmployeeID"
                options={employeeOption}
                value={employeeOption.find(
                  (o) => o.value === formData.EmployeeID
                )}
                onChange={handleSelect}
                className={errors.EmployeeID ? "is-invalid" : ""}
              />
              {errors.EmployeeID && (
                <div className="invalid-feedback">{errors.EmployeeID}</div>
              )}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                Title <span className="text-danger">*</span>
              </label>
              <Select
                name="award_id"
                options={awardTypeOption}
                value={awardTypeOption.find(
                  (o) => o.value === formData.award_id
                )}
                onChange={handleSelect}
                className={errors.award_id ? "is-invalid" : ""}
              />
              {errors.award_id && (
                <div className="invalid-feedback">{errors.award_id}</div>
              )}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">Remark</label>
              <textarea
                name="Remarks"
                value={formData.Remarks}
                onChange={handleChange}
                className={`form-control ${errors.Remarks ? "is-invalid" : ""}`}
                rows={1}
              />
              {errors.Remarks && (
                <div className="invalid-feedback">{errors.Remarks}</div>
              )}
            </div>
          </div>

          <div className="row mt-2">
            <div className="col-md-4 mb-3 d-flex align-items-center">
              <div>
                <label className="form-label me-3">Badge</label>
                <img
                  src={formData.badge || No_Image_Available}
                  alt="Badge"
                  className="img-thumbnail rounded-circle"
                  style={{
                    width: "80px",
                    height: "80px",
                    objectFit: "cover",
                  }}
                />
              </div>
              <div className="d-flex flex-column">
                <div className="mx-4"><b>Score</b> : {formData.score || ""}</div>
                <div className="mx-4"><b>Description</b> : {description || ""}</div>
              </div>
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Upload Image</label>
              <div className="d-flex align-items-center">
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleFileChange}
                  className={`form-control ${errors.image ? "is-invalid" : ""}`}
                  style={{ width: "60%" }}
                />
                {formData.imagePreview && (
                  <img
                    src={formData.imagePreview}
                    alt="Preview"
                    className="img-thumbnail rounded-circle ms-3"
                    style={{
                      width: "80px",
                      height: "80px",
                      objectFit: "cover",
                    }}
                  />
                )}
              </div>
            </div>
          </div>

          <div className="mt-4 d-flex justify-content-end">
            <button
              type="button"
              className="cancel-btn me-2"
              onClick={() => navigate("/awards")}
            >
              Cancel
            </button>
            <button type="submit" className="custom-btn"   disabled={loading} // ✅ disable button while loading
>
              {loading ? <FaSpinner className="sm-spinner" /> : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
    }

};

export default AwardEditForm;
